
import { v4 as uuidv4 } from 'uuid';

class AppPermission{
    
    id: typeof uuidv4 | undefined;
    alias: string | undefined;
}

export default AppPermission;